import React, { useEffect } from "react";
import GetStarted from "../components/GetStarted";

const GetStartedContainer = () => {
  useEffect(() => {
    document.title = "Get Started | My Music NC";
  }, []);
  
  return <GetStarted />
};

export default GetStartedContainer; 